import { FunctionComponent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { EOnboardingVariant } from "@/enum/onboarding-variant.enum";

import { ROUTE_CONFIG } from "@/routes/config";

import { useOnboardingVariant } from "@/utils/useOnboardingVariant";

import { OnboardingV3Start } from "./pages/OnboardingStartV3";

/**
 * The slim onboarding (V3, PREC-3719): everyone joining a workspace that is
 * already set up. It only asks for the user's own LinkedIn profile — the
 * workspace's ICP, lists and knowledge already exist, and the rest of the
 * introduction is the post-checkout setup guide.
 */
export const OnboardingV3: FunctionComponent = () => {
	const variant = useOnboardingVariant();

	if (variant === EOnboardingVariant.FULL || variant === EOnboardingVariant.FULL_NO_CHECKOUT) {
		return <Navigate to={ROUTE_CONFIG.ONBOARDING} />;
	}

	if (variant === EOnboardingVariant.NONE) {
		return <Navigate to={ROUTE_CONFIG.LISTS} />;
	}

	return (
		<Routes>
			<Route element={<OnboardingV3Start />} path="/" />
		</Routes>
	);
};
